import { avviaApp, ApogeoDebug } from './app'

declare global {
  interface Window { apogeo?: ApogeoDebug }
}

window.apogeo = avviaApp()
